import { BindTourHelpButtons as bindTourHelpButtons, BuilderTourStep, StartBuilderTour, StartTourOptions } from '../product-customizer/tour';

const STORAGE_KEY = 'coin-builder-tour-seen';

const TOUR_STEPS: BuilderTourStep[] = [
    {
        id: 'tour-text-input',
        targets: ['#text-input-group'],
        title: 'Add your text',
        description: 'You can add a ring of text that wraps around the image in the center. Type in these boxes ' +
            'to add text to the top and bottom of the coin, and use the controls to the right to change the size and color.',
        tab: 'text',
    },
    {
        id: 'tour-font-selector',
        targets: ['.font-family-dropdown'],
        title: 'Pick a font',
        description: 'Choose from a variety of fonts for your coin text.',
        tab: 'text',
    },
    {
        id: 'tour-metal-color',
        targets: ['#font-metal-color-btn'],
        title: 'Metal or colored text',
        description: 'Switch between engraved-metal text and filled-in colored text.',
        tab: 'text',
    },
    {
        id: 'tour-text-styles',
        targets: ['#font-style-basics'],
        title: 'Bold, italic, and underline',
        description: 'Style your text with bold, italic, or underline.',
        tab: 'text',
    },
    {
        id: 'tour-caps-lock',
        targets: ['#font-caps-btn'],
        title: 'All-caps toggle',
        description: 'Flip between all-caps and mixed case for your text.',
        tab: 'text',
    },
    {
        id: 'tour-text-separator',
        targets: ['.text-separator-options'],
        title: 'Text separators',
        description: 'Add a decorative separator between your top and bottom text — choose a dot, star, or type in your own characters.',
        tab: 'text',
    },
    {
        id: 'tour-ring-fill-toggle',
        targets: [
            '#lg-ring-fill-group',
            '.inline-ring-color.d-lg-none .ring-fill-toggle',
        ],
        title: 'Solid or transparent ring',
        description: 'Toggle whether the text ring has a solid background color or shows the coin metal through it.',
        tab: 'text',
    },
    {
        id: 'tour-ring-color',
        targets: [
            '.inline-ring-color.d-lg-flex .inline-ring-color-card',
            '.inline-ring-color.d-lg-none .inline-ring-color-card',
        ],
        title: 'Ring color',
        description: 'Click to change the background color of the text ring.',
        tab: 'text',
    },
    {
        id: 'tour-text-drop',
        targets: [
            { selector: '#lg-design-layer-list .add-text-btn', tab: 'design' },
            { selector: '#design-layer-list .add-text-btn', tab: 'design' },
            // Empty canvas hides the layer lists — fall back to the upload
            // zone's "Add text instead" button
            '#lg-upload-zone .add-text-drop-btn',
            { selector: '#upload-zone .add-text-drop-btn', tab: 'design' },
        ],
        title: 'Add text anywhere',
        description: 'Drop movable text blocks right onto the coin — drag to position, resize and rotate with ' +
            'the handles, and pull the yellow diamond to arc the text. Each block gets its own font, color, and ' +
            'styling from the floating toolbar.',
    },
    {
        id: 'tour-image-upload',
        targets: [
            { selector: '#lg-upload-zone', tab: 'design' },
            { selector: '#text-tab-upload-cta', tab: 'text' },
            { selector: '.uploads-container-label', tab: 'design' },
        ],
        title: 'Upload your artwork',
        description: 'Upload your logo or artwork. Raster (PNG, JPG) and vector formats (SVG, EPS, AI, PSD, PDF) are all supported.',
    },
    {
        id: 'tour-layer-panel',
        targets: ['#lg-design-layer-list', '#design-layer-list'],
        title: 'Manage your layers',
        description: 'Your uploads and text blocks live here — click a row to select it, drag to change the stacking order, and use the eye to hide a layer without deleting it.',
        tab: 'design',
    },
    {
        id: 'tour-side-toggle',
        targets: [
            '#coin-side-segmented',
            // On mobile/tablet the `.coin-side-toggle` container stretches to
            // fill its row — target just the switch (plus its labels) so the
            // highlight fits the actual control.
            '#coin-side-toggle .form-check',
        ],
        title: 'Design both sides',
        description: 'Switch between designing the front and back of your coin.',
    },
    {
        id: 'tour-background',
        targets: ['.lg-plating-cards', '#design-plating-group'],
        title: 'Background & plating',
        description: 'Choose the coin’s base plating color — antique brass or antique silver.',
        tab: 'design',
    },
    {
        id: 'tour-quantity-price',
        targets: ['#lg-quantity', '#quantity'],
        title: 'Quantity & price',
        description: 'Adjust the quantity to see live pricing — no minimum order required.',
    },
    {
        id: 'tour-add-to-cart',
        targets: ['#lg-add-to-cart', '#add-to-cart'],
        title: 'Add to cart',
        description: 'When you’re happy with your design, add it to your cart to order.',
    },
];

export function StartCoinBuilderTour(options: StartTourOptions = {}): void {
    StartBuilderTour({ storageKey: STORAGE_KEY, steps: TOUR_STEPS }, options);
}

/** Wire up any element matching `selector` to re-run the full tour on click. */
export function BindTourHelpButtons(selector: string): void {
    bindTourHelpButtons(selector, () => StartCoinBuilderTour({ force: true }));
}
